<app-multi-select-btn 
    [label]="'Teams'"
    [list]="teams"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>
